module.exports = __webpack_public_path__ + "static/media/register.2a6dfe42.svg";